<div class="mat-app-background lifeContainer">
  <div style="flex-grow: 1; display:flex; align-items: center;">
    <mat-icon (click)="incrementPlayer2Life()" color="primary">add_circle_outline</mat-icon>
    <mat-icon (click)="decrementPlayer2Life()" color="warn">remove_circle_outline</mat-icon>
  </div>

  <div [ngStyle]="{'font-size': adjustedFontSize + 'px'}" style="flex-grow: 1; display: flex; align-items: center; justify-content: center;">
    <p *ngIf="player2Life != 0" style="transform: rotate(180deg);">
      {{ player2Life }}
    </p>
    <p *ngIf="player2Life === 0" style="transform: rotate(180deg);">
      ☠
    </p>
  </div>
  

  <hr style="width:100%;">

  <div #player1LifeContainer [ngStyle]="{'font-size': adjustedFontSize + 'px'}" style="flex-grow: 1; display: flex; align-items: center; justify-content: center;">
    <p *ngIf="player1Life != 0">
      {{ player1Life}}
    </p>
    <p *ngIf="player1Life === 0">
      ☠
    </p>
  </div>

  <div style="flex-grow: 1; display:flex; align-items: center;">
    <mat-icon (click)="decrementPlayer1Life()" color="warn">remove_circle_outline</mat-icon>
    <mat-icon (click)="incrementPlayer1Life()" color="primary">add_circle_outline</mat-icon>
  </div>

</div>